export default __webpack_public_path__ + "static/media/expand.60ec4d3e.svg";